// Third-party Imports
import styled from '@emotion/styled'

const StyledMenuPrefix = styled.span`
  margin-inline-end: 5px;
  display: flex;
  ${({ rootStyles }) => rootStyles};
`

export default StyledMenuPrefix
